import useEntity from "../../hooks/useUser";
import UserDetail from "../../components/user/UserDetail/UserDetail";
import UserScoped from "../../components/user/UserDetail/UserScoped";
import UserTabs from "../../components/user/UserDetail/UserTabs";
import { useGetUserQuery } from "../../apis/User.api";
import { PrimaryUser } from "../../types/models/User";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserDetailPage = () => {

    useTitle(t`Details User`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { userId: id } = useParams();

    const { data, refetch } = useGetUserQuery(PrimaryUser.fromPath(id))
    const { deleteUser } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteUser(data, '..')
    }, [data, deleteUser])

    if (id === 'scoped') {
        return (<UserScoped/>)
    }

    return (
        <Box data-testid="User-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <UserDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { 
        session.hasPermission('', 'applications/auth/entities/Users/update/view') &&
                        <Button size="small" variant="outlined" data-testid="User-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { 
        session.hasPermission('', 'applications/auth/entities/Users/delete/view') &&
                        <Button size="small" color="error" variant="outlined" data-testid="User-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <UserTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default UserDetailPage;
